/* tslint:disable */
/* eslint-disable */
/**
 * NameCheck API
 * assembly version: 1.0.0.0
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BlacklistedCompanyDto,
    BlacklistedCompanyDtoFromJSON,
    BlacklistedCompanyDtoFromJSONTyped,
    BlacklistedCompanyDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface BlacklistedCompanyDtoPaginatedResultDto
 */
export interface BlacklistedCompanyDtoPaginatedResultDto {
    /**
     * 
     * @type {number}
     * @memberof BlacklistedCompanyDtoPaginatedResultDto
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof BlacklistedCompanyDtoPaginatedResultDto
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof BlacklistedCompanyDtoPaginatedResultDto
     */
    total?: number;
    /**
     * 
     * @type {Array<BlacklistedCompanyDto>}
     * @memberof BlacklistedCompanyDtoPaginatedResultDto
     */
    results?: Array<BlacklistedCompanyDto> | null;
}

export function BlacklistedCompanyDtoPaginatedResultDtoFromJSON(json: any): BlacklistedCompanyDtoPaginatedResultDto {
    return BlacklistedCompanyDtoPaginatedResultDtoFromJSONTyped(json, false);
}

export function BlacklistedCompanyDtoPaginatedResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlacklistedCompanyDtoPaginatedResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'take': !exists(json, 'take') ? undefined : json['take'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(BlacklistedCompanyDtoFromJSON)),
    };
}

export function BlacklistedCompanyDtoPaginatedResultDtoToJSON(value?: BlacklistedCompanyDtoPaginatedResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'take': value.take,
        'page': value.page,
        'total': value.total,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(BlacklistedCompanyDtoToJSON)),
    };
}


